import { render } from "./CertificadosPorModulo.vue?vue&type=template&id=a21e069c&scoped=true"
import script from "./CertificadosPorModulo.vue?vue&type=script&lang=js"
export * from "./CertificadosPorModulo.vue?vue&type=script&lang=js"

import "./CertificadosPorModulo.vue?vue&type=style&index=0&id=a21e069c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a21e069c"]])

export default __exports__